export default "/images/sidebar-2.jpg?782b7d79a2d7ed6abb68509d66c73272";